/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionChangesControllerFindAllQueryResponse, QuestionChangesControllerFindAllQueryParams, QuestionChangesControllerFindAll401, QuestionChangesControllerFindAll403 } from "../../models/checklistsController/QuestionChangesControllerFindAll";

function getQuestionChangesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-question-changes` as const }  
  return res
}

/**
 * @summary List checklist question change flags
 * {@link /api/v1/checklist-question-changes}
 */
export async function questionChangesControllerFindAll(params?: QuestionChangesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<QuestionChangesControllerFindAllQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindAll401 | QuestionChangesControllerFindAll403>, unknown>({ method : "GET", url : getQuestionChangesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}